import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label } from 'reactstrap';

class DosagesSelect extends React.PureComponent {
  handleChange = ({ target }) => {
    const { dispatch, id } = this.props;

    dispatch({
      type: 'EDIT_SITE_THEME',
      id,
      value: target.value,
    });
  };

  render() {
    const {
      id,
      children,
      values,
    } = this.props;

    return (
      <FormGroup className="text-capitalize">
        <Label for={id} className="font-weight-bold">
          {children}
        </Label>
        <select
          className="form-control"
          id={id}
          value={values[id] || ''}
          onChange={this.handleChange}
        >
          <option>{' '}</option>
          {values.dosages.map((dosage) => dosage.id).map((d) => <option key={d}>{d}</option>)}
        </select>
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.sites.values,
});

export default connect(mapStateToProps)(DosagesSelect);
